import React from 'react';
import PropTypes from 'prop-types';
import InputsUnit from '../../../../../../../../../../../../components/UIComponents/Fields/InputsUnit2';
import optionsLengthUnits from '../../../../../../../../../../../../utils/units/optionsLengthUnits2';

const HollowCircleSection = ({
  sectionType,
  sections,
  changeGeometry
}) => {
  return (
    <div>
      <InputsUnit
        label={sections.listSectionTypes.hollowCircleSection.inputs.D.text}
        inputName="sections.listSectionTypes.hollowCircleSection.inputs.D.value"
        selectList={optionsLengthUnits}
        selectName="sections.listSectionTypes.hollowCircleSection.inputs.D.unit"
        tooltipDescription={sections.listSectionTypes.hollowCircleSection.inputs.D.description}
        tooltipTarget={sections.listSectionTypes.hollowCircleSection.inputs.D.name}
        onChange={(e) => {
          const val = e.target.value;
          changeGeometry(sections.listSectionTypes.hollowCircleSection.inputs, sectionType, val, sections.listSectionTypes.hollowCircleSection.inputs.D.name);
        }}
      />
      <InputsUnit
        label={sections.listSectionTypes.hollowCircleSection.inputs.t.text}
        inputName="sections.listSectionTypes.hollowCircleSection.inputs.t.value"
        selectList={optionsLengthUnits}
        selectName="sections.listSectionTypes.hollowCircleSection.inputs.t.unit"
        tooltipDescription={sections.listSectionTypes.hollowCircleSection.inputs.t.description}
        tooltipTarget={sections.listSectionTypes.hollowCircleSection.inputs.t.name}
        onChange={(e) => {
          const val = e.target.value;
          changeGeometry(sections.listSectionTypes.hollowCircleSection.inputs, sectionType, val, sections.listSectionTypes.hollowCircleSection.inputs.t.name);
        }}
      />
    </div>
  );
};

export default HollowCircleSection;
